import { useTranslation } from '@web_opxp/features';
import { SKELETON_CLASSNAME } from '../../base/constants';
import { formatDateToString } from '../../base/dateUtils';
import { IOrder } from '../types';
import InvoiceLink from './InvoiceLink';
import styles from './OrdersList.module.scss';

export interface IOrdersListItemProps {
  order: IOrder;
}

export default function OrdersListItem({ order }: Readonly<IOrdersListItemProps>) {
  const { language } = useTranslation();
  const { referenceId, date, total, invoiceUrl, channel } = order;
  const invoiceDate = formatDateToString(date);
  const skeletonClassname = language ? '' : ' ' + SKELETON_CLASSNAME;
  const orderTotal = Number(total.amount).toFixed(2);
  return (
    <tr className={`${styles.ordersListItem}${skeletonClassname}`} data-testid="orders-list-item">
      <td>
        <span>{referenceId}</span>
      </td>
      <td>
        <span>{invoiceDate}</span>
      </td>
      <td>
        <span>
          {orderTotal} {total.currency}
        </span>
      </td>
      <td>
        <InvoiceLink invoiceUrl={invoiceUrl} channel={channel} />
      </td>
    </tr>
  );
}
